export default {"src":"/_next/static/media/ribbon.bf036490.svg","height":69,"width":68,"blurWidth":0,"blurHeight":0};